import { SearchProps } from "antd/lib/input";
import { useTranslation } from "react-i18next";
import { StyledSearchInput } from "./styled";

interface ISearchInput extends SearchProps {}

export const SearchInput = (props: ISearchInput) => {
  const { t, i18n } = useTranslation();

  return (
    <StyledSearchInput
      {...props}
      placeholder={t("main.searchInputPlaceholder")}
      direction={i18n.language === "ar" || i18n.language === "fa" ? "rtl" : "ltr"}
    />
  );
};
